import { useEffect, useState } from 'react';
import { api, type Me } from '../api';
import { useReloadMe } from '../../App';
import { ErrorBox, Loading } from '../components/bk';
import { TimezoneSelect } from '../components/TimezoneSelect';

export function Settings() {
  const [me, setMe] = useState<Me | null>(null);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);
  const reloadMe = useReloadMe();

  useEffect(() => {
    api.get<{ profile: Me | null }>('/api/me').then((r) => (r.profile ? setMe(r.profile) : setError('Your profile is not available here.'))).catch((e) => setError(e.message));
  }, []);
  if (!me) return error ? <ErrorBox error={error} /> : <Loading />;

  const save = async () => {
    setError('');
    try {
      setMe(await api.put<Me>('/api/me', me));
      setSaved(true);
      void reloadMe();
      setTimeout(() => setSaved(false), 1500);
    } catch (e) {
      setError((e as Error).message);
    }
  };

  return (
    <>
      <div className="pagehead"><h1>Settings</h1></div>
      <ErrorBox error={error} />
      <section className="card">
        <h2>Profile</h2>
        <div className="field">
          <label htmlFor="name">Display name</label>
          <input id="name" type="text" value={me.name} onChange={(e) => setMe({ ...me, name: e.target.value })} />
        </div>
        <div className="field">
          <label>Email</label>
          <input type="text" value={me.email} disabled />
        </div>
        <div className="field">
          <label htmlFor="tz">Time zone</label>
          <TimezoneSelect id="tz" value={me.timezone} onChange={(timezone) => setMe({ ...me, timezone })} />
          <div className="hint">
            Starts as your company's time zone. It's used for your Meetings list, your emails and as the default for new
            links. Clients always see times in their own time zone.
          </div>
        </div>
      </section>
      <section className="card">
        <h2>Conference call</h2>
        <p className="muted small">Used by links whose meeting type is "Conference call".</p>
        <div className="two">
          <div className="field">
            <label htmlFor="dial">Dial-in number</label>
            <input id="dial" type="tel" value={me.phoneDialIn ?? ''} placeholder="+1 555 010 0000" onChange={(e) => setMe({ ...me, phoneDialIn: e.target.value })} />
          </div>
          <div className="field">
            <label htmlFor="pin">Access code</label>
            <input id="pin" type="text" value={me.phonePasscode ?? ''} onChange={(e) => setMe({ ...me, phonePasscode: e.target.value })} />
          </div>
        </div>
      </section>
      <section className="card">
        <h2>Webex</h2>
        <p className="muted small">Used by links whose meeting type is "Webex". Every booking joins your personal room.</p>
        <div className="field">
          <label htmlFor="wx">Personal room link</label>
          <input id="wx" type="url" inputMode="url" placeholder="https://yourcompany.webex.com/meet/yourname" value={me.webexRoomUrl ?? ''}
            onChange={(e) => setMe({ ...me, webexRoomUrl: e.target.value })} />
        </div>
      </section>
      <div className="row" style={{ justifyContent: 'flex-end' }}>
        {saved && <span className="muted">Saved</span>}
        <button className="primary" onClick={save}>Save settings</button>
      </div>
    </>
  );
}
